angular.module('impactx.b2b').controller('CustomerCompaniesListCtrl', [
    'selectedListItems',
    '$routeParams',
    '$mdDialog',
    'ListHelperService',
    '$scope',
    'ConfirmationService',
    '$redirect',
    'ToastService',
    'TranslationService',
    'dataGen',
    CustomerCompaniesListCtrl
]);

function CustomerCompaniesListCtrl(selectedListItems, $routeParams, $mdDialog, ListHelperService, $scope,
                                   ConfirmationService, $redirect, ToastService, TranslationService, dataGen) {
    var self = this;

    this.deleteEntry = function (event) {
        var selectedItems = JSON.parse(JSON.stringify(selectedListItems.getSelectedItems()));
        ConfirmationService.showConfirmationDialog(function () {
            dataGen.postAsForm({}, {id: selectedListItems.getFirstSelectedId()}, "/b2b/customercompany/delete").then(function () {
                ToastService.openStandardToast(TranslationService.get('deleteSuccess'));
                ListHelperService.refreshListData($scope, 'customerCompaniesListCtrl', {unselectRows: selectedItems});
            });
        }, event, TranslationService.get('confirmDelete'), TranslationService.get('delete'), TranslationService.get('abort'));
    }

    this.canEdit = function () {
        return selectedListItems.isSingleSelection() && !selectedListItems.getFirstSelectedItem().deleted;
    }

    this.editCustomerCompany = function (event) {
        var selectedItems = JSON.parse(JSON.stringify(selectedListItems.getSelectedItems()));
        $mdDialog.show({
            controller: "EditCustomerCompanyCtrl",
            controllerAs: "editCustomerCompanyCtrl",
            templateUrl: "modules/b2b/templates/edit-customer-company.dialog.html",
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: true,
            bindToController: true,
            locals: {
                userId: $routeParams.userId,
                id: selectedListItems.getFirstSelectedId()
            }
        }).then(function () {
            ListHelperService.refreshListData($scope, 'customerCompaniesListCtrl', {unselectRows: selectedItems});
        });
    };

    this.newCustomerCompanyEntry = function (event) {
        var selectedItems = JSON.parse(JSON.stringify(selectedListItems.getSelectedItems()));
        $mdDialog.show({
            controller: "EditCustomerCompanyCtrl",
            controllerAs: "editCustomerCompanyCtrl",
            templateUrl: "modules/b2b/templates/edit-customer-company.dialog.html",
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: true,
            bindToController: true,
            locals: {
                userId: $routeParams.userId,
                id: 0
            }
        }).then(function () {
            ListHelperService.refreshListData($scope, 'customerCompaniesListCtrl', {unselectRows: selectedItems});
        });
    };

    var buttonDefinition = [
        {
            label: "details",
            action: self.editCustomerCompany,
            condition: self.canEdit,
            process: 'AssignCustomerCompanies'
        },
        {
            label: "delete",
            type: 'dialogaction',
            action: self.deleteEntry,
            condition: self.canEdit
        }
    ];

    this.meta = {
        buttonDefinition: buttonDefinition,
        rowTemplate: 'modules/b2b/templates/customercompanies.row.html',
        isSelectAble: true,
        ctrl: this,
        endpoint: '/b2b/customercompanies/list',
        id: "customercompanieslist",
        mainActionFunction: {id: "new", action: self.newCustomerCompanyEntry, icon: "mdi-plus"},
        excelExport: true,
        valuesInteger: [{name: "USR_Id", value: $routeParams.userId}]
    };

    this.getMeta = function () {
        return this.meta;
    };
}
